:host {
  ::slotted(stzh-hr) {
    margin-top: space("xsmall");
    margin-bottom: space("xsmall");
  }
}

.stzh-menu {
  display: flex;
  flex-direction: column;
}
